import { render, staticRenderFns } from "./premium-transparent.vue?vue&type=template&id=312a6e9b&scoped=true"
import script from "./premium-transparent.vue?vue&type=script&lang=js"
export * from "./premium-transparent.vue?vue&type=script&lang=js"
import style0 from "./premium-transparent.vue?vue&type=style&index=0&id=312a6e9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312a6e9b",
  null
  
)

export default component.exports